import { AppLink } from "@base/ui/AppLink";
import { useSafeAreaInset } from "@base/ui/SafeArea/useSafeAreaInset";
import { House } from "lucide-react";

export function BottomNav() {
  const safeArea = useSafeAreaInset();

  return (
    <nav
      style={{ paddingBottom: `calc(1rem + ${safeArea.bottom}px)` }}
      className="flex fixed right-0 bottom-0 left-0 justify-center items-center px-4 pt-4 bg-white md:hidden"
    >
      <AppLink to="/" className="text-label3 text-blue-500 flex flex-col gap-2 items-center">
        <House width={20} height={20} />
        Home
      </AppLink>
    </nav>
  );
}
